import React, { useRef } from 'react';
import { isMobile } from 'react-device-detect';

import { useSaveScroll } from 'shared/hooks/useSaveScroll';
import { Box } from 'shared/ui/Box';

import { ContentStyled, RootStyled } from './styled';

type Props = {
  sidebar: React.ReactNode;
  children: React.ReactNode;
  header: React.ReactNode;
  nameForSaveScroll?: string;
  isNeedRemoveScrollOnReboot?: boolean;
};

export const Layout = ({ sidebar, children, header, nameForSaveScroll, isNeedRemoveScrollOnReboot }: Props) => {
  const rootRef = useRef<HTMLDivElement>(null);

  useSaveScroll(rootRef, nameForSaveScroll, isNeedRemoveScrollOnReboot);

  return (
    <RootStyled id='#root' ref={rootRef}>
      {sidebar}
      <ContentStyled pr={isMobile ? 0 : 6}>
        {header}
        <Box mt={isMobile ? 90 : 0} pb={6} px={isMobile ? 4 : 0}>
          {children}
        </Box>
      </ContentStyled>
    </RootStyled>
  );
};
